import { Navigate } from 'react-router-dom';
import React from 'react';

export default function RedirectPage() {
  const getPage = () => {
    if (window.location.pathname === '/ambassadors/') {
      return <Navigate to="/ambassadors" />;
    }
    if (window.location.pathname === '/affiliates/') {
      return <Navigate to="/affiliates" />;
    }
    if (window.location.pathname === '/hotels/booking/') {
      return <Navigate to="/hotel" />;
    }
    // window.location.href = 'https://www.meetselect.com';
    return <Navigate to="/hotel" />;
  };
  return getPage();
}
